import React, { Component } from 'react';

export default class ProductListSearch extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sort: props.sortedBy,
      searchTerm: props.searchedBy
    };
    this.handleSortChange = this.handleSortChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleAdvancedSearch = this.handleAdvancedSearch.bind(this);
  }

  handleSortChange(event) {
    this.setState({ sort: event.target.value });
    this.props.handleSort(event.target.value);
  }

  handleSearchChange(event) {
    var text = event.target.value;
    this.setState({ searchTerm: text });
    this.props.handleSearch(text);
    // todo: implement this, might not be necessary
  }

  handleAdvancedSearch(event) {
    // todo: implement this, might not be necessary
  }

  render() {
    var brandOptions = this.props.brands.map(brand => <option key={brand.id} value={brand.id}>{brand.name}</option>);
    var categoryOptions = this.props.categories.map(category => <option key={category.id} value={category.id}>{category.name}</option>);

    return (
      <div className="row">
        <div className="col-lg-6 mb-3 mb-lg-0">
          <form className="form-inline justify-content-lg-start text-sm">
            <label className="control-label mr-2">{this.props.getTranslatedText("Keyword")}:</label>
            <input type="text" className="form-control form-control-sm mr-lg-2" placeholder="ie. Kosan gas" onChange={this.handleSearchChange} value={this.state.searchTerm} />
            {/*<a href="#adv-search" data-toggle="collapse" className="text-sm">advanced search</a>*/}
          </form>
        </div>
        <div className="col-lg-6">
          <form className="form-inline justify-content-lg-end text-sm">
            <label className="control-label mr-2">Sort By:</label>
            <select className="form-control form-control-sm" value={this.state.sort} onChange={this.handleSortChange}>
              {/*<option value="#" selected="">Most Popular</option>*/}
              <option value="namea">Name (A - Z)</option>
              <option value="namez">Name (Z - A)</option>
              <option value="branda">Brand (A - Z)</option>
              <option value="brandz">Brand (Z - A)</option>
            </select>
            {/*<label className="control-label mr-2 ml-lg-3">Show:</label>
            <select className="form-control form-control-sm">
              <option value="#">30</option>
              <option value="#">50</option>
              <option value="#">100</option>
              <option value="#">All</option>
            </select>*/}
          </form>
        </div>
        <div className="col-lg-12 collapse" id="adv-search">
          {/*<!-- Advanced search form -->*/}
          <form className="mt-3 bg-faded p-3 rounded mb-4 text-sm">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label>Category</label>
                <select className="form-control" defaultValue="all">
                  <option key="all" value="all">All</option>
                  {categoryOptions}
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <label>Brand</label>
                <select className="form-control" defaultValue="all">
                  <option key="all" value="all">All</option>
                  {brandOptions}
                </select>
              </div>
              {/*<div className="col-md-6 mb-3">
                <label>Price</label>
                <div className="row">
                  <div className="input-group col-md-6">
                    <span className="input-group-addon">$</span>
                    <input type="text" className="form-control" placeholder="from" />
                  </div>
                  <div className="input-group col-md-6">
                    <span className="input-group-addon">$</span>
                    <input type="text" className="form-control" placeholder="to" />
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label>Size</label>
                <select className="form-control">
                  <option value="#">Small</option>
                  <option value="#">Medium</option>
                  <option value="#">Large</option>
                  <option value="#">Extra Large</option>
                </select>
              </div>*/}
              <div className="col-md-12">
                <button type="submit" className="btn btn-primary" onClick={this.handleAdvancedSearch}> <i className="fa fa-search"></i> Search </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }
}






// WEBPACK FOOTER //
// ./src/component/ProductListSearch.js